import { Region } from '@lemon8/webapp-shared/i18n';
import { InteractionCounter, Person } from 'schema-dts';
import { IUserDetail } from 'shared/models';

export const UserJsonLDUtil = {
  getPersonJsonLD: (props: { user: IUserDetail; userRegion: Region }): Person => {
    const { user, userRegion } = props;

    const person: Person = {
      '@type': 'Person',
      url: `https://www.lemon8-app.com/${user.linkName}?region=${userRegion}`,
      name: user.nickName,
      alternateName: user.linkName,
      identifier: {
        '@type': 'PropertyValue',
        propertyID: 'Username',
        value: user.linkName,
      },
    };

    const interactionStatistic: InteractionCounter[] = [];

    if (user.dugCount || user.favoredCount) {
      interactionStatistic.push({
        '@type': 'InteractionCounter',
        interactionType: {
          '@type': 'LikeAction',
        },
        userInteractionCount: Number(user.dugCount) + Number(user.favoredCount),
      });
    }

    if (user.followerCount || user.followingCount) {
      interactionStatistic.push({
        '@type': 'InteractionCounter',
        interactionType: {
          '@type': 'FollowAction',
        },
        userInteractionCount: Number(user.followerCount) + Number(user.followingCount),
      });
    }

    if (user.postCount) {
      interactionStatistic.push({
        '@type': 'InteractionCounter',
        interactionType: {
          '@type': 'WriteAction',
        },
        userInteractionCount: Number(user.postCount),
      });
    }

    person.interactionStatistic = interactionStatistic;

    return person;
  },
};
